import { LinkedLinkProps } from 'shared-definitions/types'
import { pLinkExternalMapper } from './pLinkMapper'

export function optionalLinkMapper(input?: string | null): null | LinkedLinkProps {
  if (!input) {
    return null
  }
  return pLinkExternalMapper(input)
}
